import BaseModel from "./BaseModel";
import type BaseModelMap from "./BaseModelMap";
import type BaseObject from "./BaseObject";

export default class ObjectRegistry {
  allObjects = new Map<string, BaseObject>();
  deletedIds = new Array<string>();

  registerObject(obj: BaseObject) {
    this.allObjects.set(obj.id, obj);
  }

  getObject<T extends BaseObject>(id: string | undefined): T | undefined {
    if (id) {
      const obj = this.allObjects.get(id);
      if (obj) {
        return obj as T;
      }
    }
    return undefined;
  }

  getParentCollectionOfObject(obj: BaseObject): BaseModelMap<BaseModel> | undefined {
    for (const [key, value] of this.allObjects) {
      if (value.className == "BaseModelMap") {
        const baseModelMap = value as BaseModelMap<BaseModel>;
        for (const [key, value] of baseModelMap.items) {
          if (value == obj) {
            return baseModelMap;
          }
        }
      }
    }
    return undefined;
  }

  removeObject(obj: BaseObject): void {
    this.allObjects.delete(obj.id);
  }

  clear() {
    this.allObjects.clear();
    this.deletedIds = new Array<string>();
  }

  clearIsSaved() {
    this.allObjects.forEach((obj) => {
      obj.isSaved = false;
    });
  }

  addToDeletedObjects(obj: BaseObject) {
    this.deletedIds.push(obj.id);
  }

  removeFromDeletedObjects(obj: BaseObject) {
    const i = this.deletedIds.indexOf(obj.id);
    if (i >= 0) {
      this.deletedIds.splice(i, 1);
    }
  }
}
